import { Component, OnInit } from '@angular/core';
import { SharedserviceService } from 'src/app/services';
import { ToastrManager } from 'ng6-toastr-notifications';

@Component({
  selector: 'app-bank-details',
  templateUrl: './bank-details.component.html',
  styleUrls: ['./bank-details.component.scss']
})
export class BankDetailsComponent implements OnInit {
  list_data: any;
  count: any;
  ownerData: any;
  constructor( public sharedService: SharedserviceService , private toastr: ToastrManager) { 
    this.ownerData = JSON.parse(sessionStorage.getItem("ownerData"))
  }

  ngOnInit(): void { 
    this.showList();
  } 
  showList(){
    var self = this;
     self.sharedService.get('v1/bank/list').subscribe((res:any) =>{
      if (res.replyCode == "success") {
        this.list_data = res.data.rows;
        this.count = res.data.count; 
        console.log("Count:::",this.count);
        
        console.log("data::::",this.list_data)
      }
     },err=> {
      this.toastr.errorToastr(err.error.replyMsg, "Error");
    })
    
  }

}
